import React from 'react'
import {observer} from 'mobx-react-lite'
import {Button} from '@components/common/button/button'
import {Lang} from 'yougile-lang'
import FlyingLetterIcon from '../icon-flying-letter.svg'
import {Popup} from '@components/common/popup/popup'
import {useRequestCreatedPopup} from './use-request-created-popup'

export const RequestCreatedPopup = observer(() => {
  const {close} = useRequestCreatedPopup()

  const footer = <Button onClick={close}>{Lang.msg.close}</Button>

  return (
    <Popup
      width={584}
      autoHeight={true}
      close={close}
      title={Lang.msg.profilePage.emailChange}
      footer={footer}
    >
      <div className="flex flex-col gap-16 mx-16 pt-16 items-center">
        <FlyingLetterIcon />
        <span className="font-semibold">
          {Lang.msg.profilePage.emailChangeAfterSentence1}
        </span>
        <span>{Lang.msg.profilePage.emailChangeAfterSentence2}</span>
      </div>
    </Popup>
  )
})
